"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasSearchableSelectValidationError = exports.filterOptions = void 0;
var _lodash = require("lodash");
var filterOptions = function filterOptions(option, searchText) {
  if (!searchText || !option) {
    return true;
  }
  var lowerCaseSearch = (0, _lodash.toLower)(searchText);
  var lowerCaseOptionValue = (0, _lodash.toLower)(option.data.name);
  if ((0, _lodash.includes)(lowerCaseOptionValue, lowerCaseSearch)) {
    return true;
  } else {
    return false;
  }
};
exports.filterOptions = filterOptions;
var hasSearchableSelectValidationError = function hasSearchableSelectValidationError(_ref) {
  var form = _ref.form,
    fieldName = _ref.fieldName,
    hasErrorOnBlur = _ref.hasErrorOnBlur;
  var getFieldsError = form.getFieldsError,
    isFieldTouched = form.isFieldTouched;
  var formErrors = getFieldsError();
  var fieldHasValidationError = !!formErrors[fieldName];
  return fieldHasValidationError && isFieldTouched(fieldName) || hasErrorOnBlur;
};
exports.hasSearchableSelectValidationError = hasSearchableSelectValidationError;